import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePage.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import AllServicesData from '../ServicesPage/AreaData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img11 from '../../Images/11.jpg'
import img12 from '../../Images/12.jpg'
import img22 from '../../Images/22.jpg'
import img23 from '../../Images/23.jpg'

export default function HomePage({ CitiePhone, locationsMain, CitiesData }) {

    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE ROCKET HOME SERVICES?",
                "content": "Rocket offers a full range of professional services for your entire home—air quality, fire safety, energy efficiency, and structural protection. With years of experience, skilled technicians, and a commitment to customer satisfaction, we deliver reliable results that homeowners trust."
            },
            {
                "title": "WHAT SERVICES DO YOU PROVIDE?",
                "content": "We specialize in air duct and dryer vent cleaning, chimney and fireplace sweeping, roof repair and replacement, HVAC system services, and attic insulation. Whether it's improving air quality or protecting your roof, Rocket handles it all under one roof."
            },
            {
                "title": "DO YOU OFFER FREE ESTIMATES?",
                "content": "Yes! We offer free consultations and on-site estimates for most of our services. Whether it’s a new HVAC install, roof inspection, or chimney evaluation, you’ll know exactly what to expect—no surprises, no obligations."
            },
            {
                "title": "CAN YOU PROVIDE SAME-DAY SERVICE?",
                "content": "Absolutely. For many of our services like air duct cleaning, chimney sweeping, and urgent roof or HVAC repairs, we offer same-day or next-day appointments depending on availability. Just call to check our schedule."
            },
            {
                "title": `DO YOU SERVE ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "MY AREA"} AND NEIGHBORING TOWNS?`,
                "content": `Yes! Rocket proudly serves ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding communities within a 75-mile radius. Whether you're in a city or a nearby suburb, we’ll come to you.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking is easy! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or complete our <a href='#book'>online scheduling form</a>. Our team will confirm your time and answer any questions about the service you need.`
            },
            {
                "title": "HOW OFTEN SHOULD I CLEAN AIR DUCTS & DRYER VENTS?",
                "content": "We recommend cleaning air ducts every 3–5 years, and dryer vents at least once a year to prevent fire hazards, improve air quality, and boost efficiency."
            },
            {
                "title": "WHEN SHOULD I SCHEDULE A CHIMNEY OR ROOF INSPECTION?",
                "content": "Chimneys should be inspected and cleaned annually before the cold season. Roofs should be inspected at least once a year or after any major storm to prevent costly damage."
            }
        ]
    };

    const styles = {
        bgColor: '#FBF6E9',
        titleTextColor: '#182d43',
        titleTextSize: '18px',
        rowTitleColor: '#182d43',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Rocket AirCare" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Rocket AirCare from title)(if no keywords just do for chimney sweep) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);

    return (
        <div className="HomePage" id="homepage">
            <Helmet>
                {/* <!-- TITLE --> */}
                <title>Rocket Air Care | Air, Chimney, Roofing, HVAC & More | 866-950-4606</title>

                {/* <!-- META TITLE (max 35 characters) --> */}
                <meta name="title" property="title" content="Rocket Air Care | Air, Chimney, Roofing, HVAC & More | 866-950-4606" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Rocket Air Care | Air, Chimney, Roofing, HVAC & More | 866-950-4606" data-react-helmet="true" />

                {/* <!-- META INFO --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og-image.jpg" data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.rocketaircare.com/" data-react-helmet="true" />

                {/* <!-- DESCRIPTION --> */}
                <meta name="description" content="Rocket Air Care Offers Expert Air Duct Cleaning, Chimney Care, Roofing Repair, HVAC Service & Attic Insulation For A Safer, Healthier Home." data-react-helmet="true" />
                <meta name="og:description" property="og:description" content="Rocket Air Care Offers Expert Air Duct Cleaning, Chimney Care, Roofing Repair, HVAC Service & Attic Insulation For A Safer, Healthier Home." data-react-helmet="true" />

                {/* <!-- SITE NAME --> */}
                <meta name="og:site_name" property="og:site_name" content="Rocket Air Care" data-react-helmet="true" />

                {/* <!-- KEYWORDS --> */}
                <meta name="keywords" content="Air Duct Cleaning, Dryer Vent Cleaning, Chimney Sweep, Chimney Repair, Fireplace Cleaning, Roof Repair, Roof Replacement, HVAC Service, AC Repair, Heating Repair, Attic Insulation, Air Quality Services, Chimney Inspection, Roof Leak Fix, Furnace Maintenance, Duct Repair, Roofing Contractor, Local Chimney Experts, Attic Energy Savings" data-react-helmet="true" />
            </Helmet>

            {/* MainBanner */}
            <div className="MainBanner" >
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftRight">

                        <img className="bannerlogopng" src={require(`../../ImagesLogos/Logo1.png`)} />
                        <h1>Don’t Stress — Call Rocket Air Care</h1>
                        <h4>Your Trusted Experts For <b>Air Duct and Dryer Vent, Roofing, Chimney and Fireplace, HVAC & Attic Insulation</b> in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b></h4>
                        <h2>From attic to foundation, Rocket delivers top-rated service in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. Call us today at <span>{CitiePhone}</span> to book air duct cleaning, chimney sweeping, HVAC repair, roofing, and more!</h2>

                        <h3><img src={require(`../../Images/check.png`)} />Affortable Pricing & No Hidden Fees</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Fully stocked trucks</h3>
                        <h3><img src={require(`../../Images/check.png`)} />1800+ 5-Star Reviews</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                        </div>
                        <div className="MainBannerLeftRated" >
                            <h3>Rated 5 on Google</h3>
                            <span>
                                <h4>5</h4>
                                <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                            </span>
                        </div>
                    </div>
                    <div className="MainBannerLeftLeft">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                    </div>

                </div>
                <div className="MainBannerImg">
                    <img src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
            </div>
            {/* <div className="contactInfo">
                <h1>Contact Info</h1>
                <h2>Address: 230 S Bemiston Ave, Suit 201 Clayton, Missouri, 63105, United States</h2>
                <h2>Phone: 205-825-8976</h2>
                <h2>Name: Rocket Air Care</h2>
            </div> */}
            {/* HomePageReviews */}
            <div className="HomePageReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="HomePageReviewsList">
                    <img className="bannerlogopng" src={require(`../../Images/review1airduct.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/chimneyreview1.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/review3airduct.png`)} />
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">

                    {/* AIR DUCT & DRYER VENT */}
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Before1.jpeg`)} alt="Air Duct & Dryer Vent Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>AIR DUCT & DRYER VENT</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Duct & Vent Cleaning</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Allergen & Lint Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Fire Hazard Prevention</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Duct Repairs & Sealing</h2>
                        </div>
                    </a>

                    {/* CHIMNEY & FIREPLACE */}
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimnneyinspection.webp`)} alt="Chimney and Fireplace" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>CHIMNEY & FIREPLACE</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Chimney Sweeping</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Fireplace Cleaning</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Crown, Cap & Damper Repairs</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Chimney Inspections</h2>
                        </div>
                    </a>

                    {/* ROOFING SERVICES */}
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roof1b.png`)} alt="Roofing Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>ROOFING SERVICES</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Leak Repairs & Patching</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Shingle & Tile Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Roof Installation & Replacement</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Emergency Roofing Services</h2>
                        </div>
                    </a>

                    {/* HVAC & ATTIC INSULATION */}
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/hvac.webp`)} alt="HVAC & Attic Insulation" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>HVAC & ATTIC INSULATION</h3>
                            <h2><img src={require(`../../Images/check.png`)} />AC & Furnace Repairs</h2>
                            <h2><img src={require(`../../Images/check.png`)} />New HVAC Installations</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Blown-In Insulation</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Energy Efficiency Upgrades</h2>
                        </div>
                    </a>

                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>

            {/* Main service categories — each with its own sub-services */}
            {!location.pathname.startsWith("/local") && (<div className="CategoryBlocks CategoryBlocks-Hide-On-Local">
                {[
                    { key: "airduct", label: "Air Duct", href: "/airduct", match: (a) => /air duct|hvac duct|air vent|coil cleaning|mold removal from air|uv air|anti-microbial duct|indoor air quality|furnace cleaning/i.test(a.Title) },
                    { key: "chimney", label: "Chimney & Fireplace", href: "/chimney", match: (a) => /chimney|fireplace|creosote|smoke chamber|masonry|tuckpoint|wood stove|gas fireplace|pellet stove|insert/i.test(a.Title) },
                    { key: "dryer", label: "Dryer Vent", href: "/dryer", match: (a) => /dryer|lint|bird guard/i.test(a.Title) },
                    { key: "hvac", label: "HVAC", href: "/hvac", match: (a) => /hvac|^ac |furnace repair|furnace install|heat pump|mini-split|thermostat|refrigerant/i.test(a.Title) },
                    { key: "roofing", label: "Roofing & Gutters", href: "/roofing", match: (a) => /roof|gutter|skylight|soffit|fascia/i.test(a.Title) },
                ].map((cat) => {
                    const subs = AllServicesData.filter(cat.match).slice(0, 8);
                    if (subs.length === 0) return null;
                    return (
                        <div key={cat.key} className={`CategoryBlock CategoryBlock-${cat.key}`}>
                            <div className="CategoryBlockHeader">
                                <h2>{cat.label}</h2>
                                <a href={cat.href}>View {cat.label} Landing →</a>
                            </div>
                            <div className="CategoryBlockGrid">
                                {subs.map((s, i) => (
                                    <a key={i} href={s.Path} className="CategoryBlockItem">
                                        <h3>{s.Title}</h3>
                                        <p>{s.Full}</p>
                                        <span>Learn more →</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>)}

            {/* HomePageWeondawy */}
            <div className="HomePageWeondawy">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} alt="Air Duct Cleaning" />
                <h1>Stay calm, we're coming to you!</h1>

            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../Images/Before1.jpeg`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>ROCKET BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Technicians completed more than 2,500 hours of training in 2023</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 1,800+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* HomePageGoodBY */}
            <div className="HomePageGoodBY">
                <h1>SAY GOODBYE TO DIRT AND DUST IN YOUR AIR DUCTS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience cleaner, healthier air with our professional air duct cleaning services.</h2>
                <div className="HomePageGoodBYList">
                    <img src={require(`../../Images/11.jpg`)} />
                    <img src={require(`../../Images/43.jpg`)} />
                    <img src={require(`../../Images/23.jpg`)} />
                    <img src={require(`../../Images/65.jpg`)} />
                </div>
            </div>
            {/* MainBanner */}
            <div className="HomePageBook">
                <div className="MainBannerLeftRight">
                    <h1>Book Your Air Duct Cleaning Online Now in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h1>
                    <h4>Top-Rated <b>Air Duct Service</b></h4>
                    <h2>Rocket Air Care: Your Trusted Air Duct Cleaning Team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. 📅 Schedule Your Appointment Online in less then a Minute</h2>
                    <h3><img src={require(`../../Images/check.png`)} /> Affordable Pricing & No Hidden Fees – Book Online Today!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Licensed, Bonded, & Insured Professionals Ready to Serve You</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Fully Stocked Trucks for Next-Day Service – Schedule Now!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Trusted by 1800+ 5-Star Reviews – Join Our Happy Customers!</h3>
                    <div className="MainBannerLeftButtons" id="book">
                        <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 5 on Google</h3>
                        <span>
                            <h4>5</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerLeftLeft">
                    <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                </div>

            </div>
            {/* MainBanner2Top2 */}
            <div className="HomePageServices" id="ourservices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Before1.jpeg`)} alt="Air Duct Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>AIR DUCT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Dust & Allergen Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Improvement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Leak Repair</h2>
                            </div>
                            <h4>Improve indoor air quality and airflow with Rocket’s professional air duct cleaning. Our experts remove buildup, sanitize ducts, and seal leaks to create a healthier home. Breathe easier—schedule your duct cleaning today!</h4>
                            <a href="/airduct">Explore This Service</a>

                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/dryercleaning.jpg`)} alt="Dryer Vent Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>DRYER VENT CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Lint & Debris Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Clogged Vent Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Inspection & Repair</h2>
                            </div>
                            <h4>Prevent dryer fires and improve efficiency with Rocket’s dryer vent cleaning. We remove dangerous lint buildup, clear blockages, and check your venting system for safety and performance.</h4>
                            <a href="/dryer">Explore This Service</a>

                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney1.jpeg`)} alt="Chimney and Fireplace" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY & FIREPLACE</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney Sweeping</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fireplace Cleaning</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Cap & Crown Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney Inspections</h2>
                            </div>
                            <h4>Rocket Chimney provides professional chimney and fireplace services to ensure safe and efficient operation. From routine sweeping to structural repairs, we protect your home from fire hazards and heat loss while keeping your fireplace clean, cozy, and ready to use.</h4>
                            <a href="/chimney">Explore This Service</a>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/roofrepair.png`)} alt="Roofing Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>ROOFING SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Roof Leak Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Shingle & Tile Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Full Roof Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Emergency Tarping Services</h2>
                            </div>
                            <h4>Protect your property from the elements with Rocket Roofing. Whether you're dealing with leaks, storm damage, or need a new roof, our licensed experts provide fast, affordable, and durable roofing solutions. We work with all materials and offer free inspections.</h4>
                            <a href="/roofing">Explore This Service</a>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/hvac.webp`)} alt="HVAC Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>HVAC SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />AC & Heating Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />HVAC System Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Thermostat Upgrades</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Seasonal Tune-Ups</h2>
                            </div>
                            <h4>Stay cool in the summer and warm in the winter with Rocket’s full-range HVAC services. We specialize in repair, maintenance, and installation of efficient heating and cooling systems to keep your indoor climate comfortable year-round. Fast service. Reliable results.</h4>
                            <a href="/hvac">Explore This Service</a>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/attic.jpeg`)} alt="Attic Insulation" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>ATTIC INSULATION</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Blown-In Insulation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Efficiency Upgrades</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Sealing & Draft Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Insulation Removal & Replacement</h2>
                            </div>
                            <h4>Maximize comfort and minimize energy waste with professional attic insulation. Rocket provides full-service insulation upgrades that help regulate indoor temperature, reduce utility bills, and extend the life of your HVAC system. A smarter, greener home starts in the attic.</h4>
                            <a href="/attic">Explore This Service</a>
                        </div>
                    </a>

                </div>
            </div>
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At Rocket Home Services, we’re proud to provide top-rated care to homeowners in {CitiesData && CitiesData.City ? CitiesData.City : ""} and surrounding areas. For over 22 years, we’ve delivered trusted solutions in air duct and dryer vent cleaning, chimney and fireplace maintenance, roofing repair, HVAC services, and attic insulation. We’re committed to helping our community breathe easier, stay protected, and live more comfortably—no matter the season.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Rocket Home Services Booking" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>

                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>

        </div >
    )
}

